import { createAction } from '@reduxjs/toolkit';
import { CurrentUser } from './model';

export const loadUserStarted = createAction<void, 'general/LOAD_USER_STARTED'>(
  'general/LOAD_USER_STARTED',
);
export const loadUserSuccess = createAction<{ user: CurrentUser }, 'general/LOAD_USER_SUCCESS'>(
  'general/LOAD_USER_SUCCESS',
);

export const loadUserError = createAction<{ error: any }, 'general/LOAD_USER_ERROR'>(
  'general/LOAD_USER_ERROR',
);
export const scenarioBegin = createAction<{ key: string }, 'general/SCENARIO_BEGIN'>(
  'general/SCENARIO_BEGIN',
);
export const scenarioEnd = createAction<{ key: string }, 'general/SCENARIO_END'>(
  'general/SCENARIO_END',
);
export const scenarioSetState = createAction<
  { key: string; state: any },
  'general/SCENARIO_SET_STATE'
>('general/SCENARIO_SET_STATE');
